import { styled } from '@mui/material/styles';
import { Box, Container } from '@mui/material';

type ContentWrapperProps = {
  $withHelpBar: boolean;
};

export const ContentWrapper = styled(Box)<ContentWrapperProps>(({ theme, $withHelpBar }) => ({
  padding: `${theme.spacing(6)} ${theme.spacing(8)} ${theme.spacing(9)} ${theme.spacing(8)}`,
  borderRadius: '24px',
  background: theme.palette.background.paper,
  marginTop: $withHelpBar ? undefined : theme.spacing(5),
  width: '100%'
}));

export const PageWrapper = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8)
}));

export const SubtitleWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.spacing(2.25)
}));
